import React from "react";
import Lottie from "react-lottie";
import Notfound from "./json/404_Not_Found.json";

const NotFound = () => {

  const lottie1 = {
    loop: true,
    autoplay: true,
    animationData: Notfound
  };

  return (
    <>
      <div style={{ width: "100%", height: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Lottie options={lottie1} style={{ width: "200px", height: "200px" }} />
      </div>
    </>
  )
};

export default NotFound;